import React, { useEffect, useState } from 'react'
import {
	AppointmentsContainer,
	AppointmentCard,
	AppointmentInfo,
	DateBadge,
	DateDay,
	DateTime,
	AppointmentType,
	Professional,
	ClinicName,
	AppointmentsWrapper,
	AppointmentCarConteiner,
	ButtonContainer,
	VerticalDivider
} from './styled'
import moment from 'moment'
import 'moment/locale/es'
import { capitalize } from '../../utils/stringsUtils'
import { Button } from '../ui/button'
import useIsMobile from '../../hooks/useIsMobile'
import { Calendar } from '../../assets/icons'
import AddToCalendarQuickAccessModal from '../AddToCalendarQuickAccessModal'
import CancelAppointmentConfirmModal from '../CancelAppointmentConfirmModal'
import theme from '../../styled/theme'
import config from '../../config'
import { useHistory } from 'react-router-dom'
import { buildAppointmentCalendarEvent } from '../../utils/appointmentCalendarEvent'
import to from 'await-catch'
import { cancelAppointment } from '../../api'

moment.locale('es')
moment.updateLocale('es', {
	monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
})

const CANCEL_THRESHOLD = config.cancelThresholdHours

const UpcomingAppointmentsCard = ({
	appointments,
	isCarousel,
	showButtons = true,
	setShowFeedback
}) => {
	const history = useHistory()
	const isMobile = useIsMobile()
	const [showCancelModal, setShowCancelModal] = useState(false)
	const [showAddToCalendarInfo, setShowAddToCalendarInfo] = useState(false)
	const [selectedAppointment, setSelectedAppointment] = useState(null)
	const [appointmentsList, setAppointmentsList] = useState(appointments || [])

	useEffect(() => {
		const sortedAppointments = appointments?.sort(
			(a, b) => new Date(a.fechaTurnoDateTime) - new Date(b.fechaTurnoDateTime)
		)

		setAppointmentsList(sortedAppointments || [])
	}, [appointments])

	const openModal = setModalState => appointment => {
		setSelectedAppointment(appointment)
		setModalState(true)
	}

	const closeModal = setModalState => () => {
		setModalState(false)
		setSelectedAppointment(null)
	}

	const openCancelModal = openModal(setShowCancelModal)
	const closeCancelModal = closeModal(setShowCancelModal)
	const openAddToCalendarModal = openModal(setShowAddToCalendarInfo)
	const closeAddToCalendarModal = closeModal(setShowAddToCalendarInfo)

	const handleViewDetails = appointment => {
		history.push('/inicio/mis-turnos/detalle', { appointment })
	}

	const confirmCancelAppointment = async () => {
		if (!selectedAppointment) {
			return
		}
		const appointmentId = selectedAppointment.idTurno
		const clinicCode = selectedAppointment.codigoEmpresa
		const [err] = await to(cancelAppointment(appointmentId, clinicCode, 1))
		if (!err) {
			setShowFeedback({ show: true, success: true })
		} else {
			setShowFeedback({ show: true, success: false })
		}
		closeCancelModal()
	}

	const selectedCalendarEvent = buildAppointmentCalendarEvent(selectedAppointment)

	return (
		<>
			<CancelAppointmentConfirmModal
				isOpen={showCancelModal}
				onClose={closeCancelModal}
				onConfirm={confirmCancelAppointment}
				isFullHeight={isMobile}
			/>
			<AddToCalendarQuickAccessModal
				isOpen={showAddToCalendarInfo}
				onClose={closeAddToCalendarModal}
				isFullHeight={isMobile}
				event={selectedCalendarEvent}
			/>
			<AppointmentsWrapper>
				<AppointmentsContainer isCarousel={isCarousel}>
					{appointmentsList?.map(appointment => {
						const {
							id,
							idTurno,
							fechaTurnoDateTime,
							clinica,
							nombreProfesional,
							tipo = 'Presencial'
						} = appointment
						const canCancel =
							moment(fechaTurnoDateTime).diff(moment(), 'hours', true) > CANCEL_THRESHOLD
						const appointmentKey = idTurno || id || `${fechaTurnoDateTime}-${nombreProfesional}`

						return (
							<AppointmentCarConteiner key={appointmentKey}>
								<AppointmentCard
									$hasBottomBR={!showButtons}
									onClick={() => handleViewDetails(appointment)}
									onKeyDown={event => {
										if (event.key === 'Enter' || event.key === ' ') {
											event.preventDefault()
											handleViewDetails(appointment)
										}
									}}
									tabIndex={0}
									role="button"
								>
									<DateBadge>
										<DateDay>{moment.utc(fechaTurnoDateTime).format('D MMM')}</DateDay>
										<DateTime>{moment.utc(fechaTurnoDateTime).format('LT')}</DateTime>
									</DateBadge>
									<AppointmentInfo>
										<div>
											<ClinicName>{clinica}</ClinicName>
											<Professional>
												Profesional: {capitalize(nombreProfesional, true)}
											</Professional>
										</div>
										<AppointmentType>{tipo}</AppointmentType>
									</AppointmentInfo>
								</AppointmentCard>
								{showButtons && (
									<ButtonContainer justifyContent="left">
										<Button
											iconLeft={<Calendar color={theme.colors.brand.blueOmint} />}
											$showBorder={false}
											$mt={'0px'}
											label={'Agregar a calendario'}
											$variant="tertiary"
											size={isMobile ? 'mobile' : 'xlarge'}
											$underline={true}
											onClick={() => openAddToCalendarModal(appointment)}
										/>
										{canCancel && (
											<>
												<VerticalDivider />
												<Button
													$showBorder={false}
													$mt={'0px'}
													label={'Cancelar turno'}
													$variant="tertiary"
													size={isMobile ? 'mobile' : 'xlarge'}
													$underline={true}
													onClick={() => openCancelModal(appointment)}
												/>
											</>
										)}
									</ButtonContainer>
								)}
							</AppointmentCarConteiner>
						)
					})}
				</AppointmentsContainer>
			</AppointmentsWrapper>
		</>
	)
}

export default UpcomingAppointmentsCard
